const avatarUsuario =
  'https://www.rededorsaoluiz.com.br/paciente/perfil/avatars/1.png'

export default avatarUsuario
